import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

import styles from "../../assets/css/remittance.home.module.scss";
import FXRateLogo from "../../assets/img/FXRateLogo.svg";
import boosterLogo from "../../assets/img/boosterLogo.svg";
import AppSkeleton from "../../components/Skeletons/AppSkeleton";
import { baseColor, highlightColor } from "../../constants/skeletonColor";
import CurrencyConverter from "./CurrencyConverter";
import {
  loggedInExchangeRate,
  nonLoggedInExchangeRate,
} from "../../services/remittance";
import { startLoader, stopLoader } from "../../redux/slices/appSlice";
import { getUserToken } from "../../libs/user";
import { getFxRateData, handleBlendedFxRates } from "../../libs/utils";

const RemittanceHome = ({
  isMobileDevice,
  isLoggedIn = false,
  fromCalculatorPage = false,
  handleUserMigration,
}) => {
  const dispatch = useDispatch();
  const { loader } = useSelector((state) => state.app);
  const [fxRateData, setFxRateData] = useState({});
  const authToken = getUserToken();

  const {
    display_base_fx,
    display_promo_fx,
    base_fx,
    promo_fx,
    is_promo_applicable,
    // exchange_rate_currency,
    promo_condition,
    // transfer_fee_data = {},
    transaction_wise_fx_rate,
    transaction_wise_fx_rate_v2,
    // transaction_fee_data = {},
    applicable_transaction_fee_data = {},
  } = fxRateData || {};

  // const transaction_fee_data = {
  //   value: 2.79,
  //   display_value: "$2.79",
  //   currency: "$",
  // };

  const getExchangeRate = async (token) => {
    try {
      dispatch(startLoader());
      const exchangeRate = await loggedInExchangeRate(token);
      if (exchangeRate) {
        setFxRateData(exchangeRate);
        dispatch(stopLoader());
      }
    } catch (e) {
      dispatch(stopLoader());
      console.log(e);
    }
  };

  const signupExchangeRate = async () => {
    try {
      dispatch(startLoader());
      const exchangeRate = await nonLoggedInExchangeRate();
      if (exchangeRate) {
        setFxRateData(exchangeRate);
        dispatch(stopLoader());
      }
    } catch (e) {
      dispatch(stopLoader());
      console.log(e);
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      getExchangeRate(authToken);
      return;
    }
    signupExchangeRate();
  }, []);

  return (
    <>
      <div
        className={
          isMobileDevice
            ? `${styles.container} ${styles.mweb}`
            : styles.container
        }
      >
        <div className={styles.headerText}>Send Money to India</div>
        <div className={styles.swiperContainer}>
          {is_promo_applicable ? (
            <div className={styles.cardContainer}>
              <div className={styles.cardfxContainer}>
                <div className={styles.cardItemsPromotional}>
                  <div className={styles.promoBox}>
                    <div className={styles.fxguaranteelogo}>
                      <img
                        alt="FXrate"
                        src={boosterLogo}
                        className={styles.promotionallogoImg}
                      />
                    </div>
                    <div className={styles.fxRateContainer}>
                      <div className={styles.fxRateheader}>
                        <span className={styles.fxRateText}>
                          Promotional Exchange Rate
                        </span>
                      </div>
                      <div className={styles.discountedContainer}>
                        <span className={styles.fxAmount}>$1 = </span>
                        {loader ? (
                          <span>
                            <AppSkeleton
                              height={24}
                              width={72}
                              baseColor={baseColor}
                              highlightColor={highlightColor}
                              className={styles.fxAmountMargin}
                            />
                          </span>
                        ) : (
                          <>
                            <span className={styles.discountedfx}>
                              {display_base_fx}
                            </span>
                            <span className={styles.fxAmount}>
                              {display_promo_fx}
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                    <div className={styles.btnContainer}>
                      <div className={styles.compareCont}>
                        <span className={styles.compare}>Best Rate</span>
                      </div>
                    </div>
                  </div>
                  <div className={styles.validTxnContainer}>
                    <span className={styles.validTxn}>
                      {/* Valid for 1st 1000 users on transfer of up to $500 */}
                      {promo_condition}
                    </span>
                  </div>
                </div>
                <div className={styles.zeroFeeContainer}>
                  <div className={styles.zeroFeeText}>
                    Zero fees, no suprises.
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className={styles.cardContainer}>
              <div className={styles.cardfxContainer}>
                <div className={styles.cardItemNormal}>
                  <div className={styles.fxguaranteelogo}>
                    <img
                      alt="FXrate"
                      src={FXRateLogo}
                      className={styles.logoImg}
                    />
                  </div>
                  <div className={styles.fxRateContainer}>
                    <div className={styles.fxRateheader}>
                      <span className={styles.fxRateText}>
                        Best Exchange Rate. Always!
                      </span>
                    </div>

                    <div className={styles.discountedContainer}>
                      <span className={styles.fxAmount}>$1 = </span>

                      <span
                        className={`${styles.fxAmount} ${styles.fxAmountMargin}`}
                      >
                        {/* ₹{formatExchangeRate(effective_exchange_rate)} */}
                        {loader ? (
                          <AppSkeleton
                            height={24}
                            width={36}
                            baseColor={baseColor}
                            highlightColor={highlightColor}
                          />
                        ) : (
                          <>{display_base_fx}</>
                        )}
                      </span>
                    </div>
                  </div>
                  <div className={styles.btnContainer}>
                    <div className={styles.compareCont}>
                      <span className={styles.compare}>Best Rate</span>
                    </div>
                  </div>
                </div>

                <div className={styles.zeroFeeContainer}>
                  <div className={styles.zeroFeeText}>
                    Zero fees, no suprises.
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <CurrencyConverter
          fxRate={is_promo_applicable ? promo_fx : base_fx}
          displatFxRate={
            is_promo_applicable ? display_promo_fx : display_base_fx
          }
          isLoggedIn={isLoggedIn}
          handleUserMigration={handleUserMigration}
          fromCalculatorPage={fromCalculatorPage}
          baseFxRate={base_fx}
          promoFxRate={promo_fx}
          displayBaseFxRate={display_base_fx}
          displayPromoFxRate={display_promo_fx}
          transferFeeData={applicable_transaction_fee_data}
          promoLimit={500}
          transaction_wise_fx_rate={transaction_wise_fx_rate || transaction_wise_fx_rate_v2}
          exchangeData={fxRateData}
        />
      </div>
    </>
  );
};

export default RemittanceHome;
